import { render } from "./BenefitPageLayout.vue?vue&type=template&id=b92a5182&scoped=true"
import script from "./BenefitPageLayout.vue?vue&type=script&lang=js"
export * from "./BenefitPageLayout.vue?vue&type=script&lang=js"

import "./BenefitPageLayout.vue?vue&type=style&index=0&id=b92a5182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92a5182"]])

export default __exports__